/**
 * Checks in store if user is logged in.
 */

import { useAppSelector } from '../store/hooks';

// eslint-disable-next-line import/prefer-default-export
const useLoggedIn = (): boolean => {
  const isLoggedIn = useAppSelector(({ userData }) => userData?.user?.isLoggedIn);

  return !!isLoggedIn;
};

export default useLoggedIn;
